/* eslint-disable react/prop-types */
import React from 'react';
import ATooltip from '../Tooltip';

const AHeaderCell = ({ className = '', text, tooltipText }) => {
  return (
    <ATooltip placement="topLeft" title={tooltipText}>
      <div>{text}</div>
    </ATooltip>
  );
};

export default AHeaderCell;
